import { StaticStore } from "@/lib/store-factory"
import { useEffect } from "react"
import { store, StoreName } from "@/stores/stores"

function useFetchStatic(storeNames: StoreName | StoreName[]) {
  useEffect(() => {
    if (typeof storeNames === "string" && !(store[storeNames] as StaticStore<any>).fetchedError) {
      ; (store[storeNames] as StaticStore<any>).actions.fetch()
      return
    }

    if (Array.isArray(storeNames)) {
      storeNames.forEach((storeName) => {
        if (!(store[storeName] as StaticStore<any>).fetchedError) {
          ; (store[storeName] as StaticStore<any>).actions.fetch()
        }
      })
    }
  }, [storeNames])
}

export default useFetchStatic
